module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Roman.ca5b982.woff2";